import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker, { DateObject } from "react-multi-date-picker";

const HeadCount = ({ show, onClose, order, date, count, refresh }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const [fromDate, setFromDate] = useState(null);
    const [fromDateDisp, setFromDateDisp] = useState(null);
    const [toDate, setTodate] = useState(null);
    const [toDateDisp, setTodateDisp] = useState(null);

    const [updatedItems, setUpdatedItems] = useState([]);
    const [oldAmount, setOldAmount] = useState(0);
    const [newAmount, setNewAmount] = useState(0);
    const [difference, setDifference] = useState(0);
    const [newTotal, setNewTotal] = useState(0);


    const [promise_count, setpromise] = useState("");
    useEffect(() => {
        if (count) {
            setpromise(count);
        }
    }, [count]);

    useEffect(() => {
        if (date && order) {
            setFromDate(date);
            setFromDateDisp(formatDateOPt(new Date(date)));
            setTodate(order.end_date);
            setTodateDisp(formatDateOPt(new Date(order.end_date)));
        }
    }, [date, order]);

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        if (!promise_count) {
            newErrors.cnt = "This Field is Required.";
        } else if (parseInt(promise_count) === 0) {
            newErrors.cnt = "Value must be greater than 0.";
        }

        if(!toDate){
            newErrors.edate = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = {
            head_count: parseInt(promise_count, 10),
            branch_id: branch_id,
            user_id: user_id,
            start_date: date,
            end_date: toDate,
            items: updatedItems,
            amount_status: difference <= 0 ? 0 : 1,
            diff_amount:  Math.abs(difference).toFixed(2),
        };

        console.log(postData);

        axios.put(`${baseURL}/manage_corporate_order/update_head_count/${order.id}`, postData)
            .then(response => {
                onClose();
                toast.success("Head Count Updated Successfully!");
                refresh();
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Head Count Updation Failed");
            });
    };

    // display
    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    // option
    const formatDateOPt = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    //from date change
    const handleStartDateChange = (date) => {
        setFromDateDisp(date);
        if (date) {
            const formattedDate = date.format('YYYY-MM-DD');
            setFromDate(formattedDate);
        } else {
            setFromDate(null);
        }
    };

    // to date change
    const handleToDateChange = (date) => {
        setTodateDisp(date);
        if (date) {
            const formattedDate = date.format('YYYY-MM-DD');
            setTodate(formattedDate);
        } else {
            setTodate(null);
        }
    };

    // calculate amount and qty
    useEffect(() => {
        if (!fromDate || !toDate || !promise_count) {
            setUpdatedItems([]);
            return;
        }

        const newCount = Number(promise_count);
        const start = new Date(fromDate);
        const end = new Date(toDate);

        let oldAmountForRange = 0;
        let newAmountForRange = 0;

        const updatedList = order.items.map(item => {

            // Check if any date of the item lies within the range
            const isInRange = item.dates.some(dateString => {
                const itemDate = new Date(dateString);
                return itemDate >= start && itemDate <= end;
            });

            // Always calculate per-head reference
            const qtyPerHead = item.quantity / parseInt(count);
            const costPerHead = item.cost / parseInt(count);

            if (isInRange) {
                // --- OLD AMOUNT FOR THIS ITEM ---
                oldAmountForRange += Number(item.cost);

                // --- NEW CALCULATED VALUES ---
                const newQuantity = (qtyPerHead * newCount).toFixed(2);
                const newCost = (costPerHead * newCount).toFixed(2);

                newAmountForRange += Number(newCost);

                // Return updated item
                return {
                    ...item,
                    newQuantity,
                    newCost,
                    isUpdated: true
                };

            } else {
                // Not in date range → keep same
                return {
                    ...item,
                    newQuantity: item.quantity,
                    newCost: item.cost,
                    isUpdated: false
                };
            }
        });

        // Calculate difference amount
        const differenceAmount = newAmountForRange - oldAmountForRange;

        setUpdatedItems(updatedList);
        setOldAmount(oldAmountForRange);
        setNewAmount(newAmountForRange);
        setDifference(differenceAmount);
        setNewTotal(parseFloat(order.total) + parseFloat(differenceAmount));

    }, [fromDate, toDate, promise_count]);

    // table filter
    const getDisplayDate = (item, start, end) => {
        const validDates = item.dates.filter(dateString => {
            const d = new Date(dateString);
            return d >= start && d <= end;
        });

        // If a date exists inside the range, return it
        if (validDates.length > 0) return validDates[0];

        // Otherwise return empty or fallback
        return "-";
    };


    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Head Count</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-3">
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Order Id</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.catering_id}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Customer Name</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.customer.customer_name}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Customer Mobile No</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.customer.customer_number}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Order Date</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{formatDate(order.order_date)}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Company Name</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.customer.company_name ? order.customer.company_name : '-'}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Company Mobile No</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.customer.company_number ? order.customer.company_number : '-'}</label>
                            </div>
                        </div>
                    </div>

                    <div className='row mb-3'>
                        <div className="col-lg-4">
                            <label className="text-black font-w500 fs-6">From Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker placeholder='Select From Date'
                                    format="DD-MM-YYYY"
                                    value={fromDateDisp}
                                    readOnly
                                    onChange={handleStartDateChange}
                                    minDate={new Date(order.start_date).setHours(0, 0, 0)}
                                    maxDate={new Date(order.end_date).setHours(23, 59, 59)}
                                />
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <label className="text-black font-w500 fs-6">To Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker placeholder='Select To Date'
                                    format="DD-MM-YYYY"
                                    value={toDateDisp}
                                    onChange={handleToDateChange}
                                    minDate={new Date(date).setHours(0, 0, 0)}
                                    maxDate={new Date(order.end_date).setHours(23, 59, 59)}
                                />
                            </div>
                            {errors.edate && <div className="text-danger fs-8 mt-1">{errors.edate}</div>}
                        </div>

                        <div className='col-lg-4'>
                            <label className="text-black font-w500 fs-7">Head Count<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Head Count"
                                maxLength={10}
                                value={promise_count}
                                onChange={(e) => {
                                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                    setpromise(onlyNums)
                                }}
                            />
                            {errors.cnt && <div className="text-danger fs-8 mt-1">{errors.cnt}</div>}
                        </div>
                    </div>

                    {/* UPDATED ITEMS TABLE */}
                    {updatedItems.length > 0 && promise_count != count && (
                        <div className="card p-3 mt-1" style={{ maxHeight: '330px', overflowY: 'auto' }}>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0 text-black">Item Quantities & Costs</h5>

                                <div className='d-flex flex-column align-items-end'>
                                    <label className='text-black font-w600 fs-7 m-0'>New Amount</label>

                                    <label className='text-success font-w600 fs-5 py-0 d-flex align-items-center m-0'>
                                        ₹ {newTotal.toFixed(2)}

                                        {difference !== 0 && (
                                            difference > 0 ? (
                                                <span className="text-success ms-1 fs-4">
                                                    <i className="fa-solid fa-arrow-up"></i>
                                                </span>
                                            ) : (
                                                <span className="text-danger ms-1 fs-4">
                                                    <i className="fa-solid fa-arrow-down"></i>
                                                </span>
                                            )
                                        )}
                                    </label>
                                </div>
                            </div>

                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr className="text-start text-white fw-bold fs-6 gs-0 th_head">
                                        <th>Item</th>
                                        <th>Old Qty</th>
                                        <th>New Qty</th>
                                        <th>Old Cost</th>
                                        <th>New Cost</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {updatedItems
                                        .filter(item =>
                                            getDisplayDate(
                                                item,
                                                new Date(fromDate),
                                                new Date(toDate)
                                            ) !== "-"
                                        )
                                        .map((item, i) => {
                                            const displayDate = getDisplayDate(
                                                item,
                                                new Date(fromDate),
                                                new Date(toDate)
                                            );

                                            return (
                                                <tr key={i}>
                                                    <td className='text-black fs-7'>{item.name}</td>
                                                    <td className='text-black fs-7'>{item.quantity} {item.unit_name}</td>
                                                    <td className='text-black fs-7'>{item.newQuantity} {item.unit_name}</td>
                                                    <td className='text-black fs-7'>₹ {item.cost}</td>
                                                    <td className='text-black fs-7'>₹ {item.newCost}</td>
                                                    <td className='text-black fs-7'>{displayDate}</td>
                                                </tr>
                                            );
                                        })}

                                </tbody>
                            </table>
                        </div>
                    )}

                    <div className="d-flex align-items-end justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Head count<i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div >
        </Modal >
    );
};

export default HeadCount;
